<template>
    <v-layout class="layout-has_background" column align-center justify-space-between>
        <v-layout justify-space-between w-100>
            <v-flex xs4>
                <span class="home-user_name">{{ getUserName }}</span>
            </v-flex>
            <v-flex xs4>
                <!--                <img src="/static/img/logo.png" class="home-img" alt="logo" style="max-width: 100%"/>-->
            </v-flex>
            <v-flex xs4 text-right>
                <v-btn class="btn-clear">Помощь</v-btn>
                <v-btn class="btn-clear" @click="logOut">Выйти</v-btn>
            </v-flex>
        </v-layout>
        <v-layout justify-space-between>
            <v-flex v-if="getUserRole === 3 || getUserRole === 1 || getUserRole === -1">
                <router-link to="/orderBooking">
                    <v-card class="v-card--accounts">
                        <v-responsive>
                            <img src="/static/img/root/1.svg" alt=""/>
                            <v-card-text class="px-0">Заказы и бронирование</v-card-text>
                        </v-responsive>
                    </v-card>
                </router-link>
            </v-flex>
            <v-flex v-if="getUserRole === 4 || getUserRole === 1 || getUserRole === -1">
                <router-link to="/smm">
                    <v-card class="v-card--accounts">
                        <v-responsive>
                            <img src="/static/img/root/2.svg" alt=""/>
                            <v-card-text class="px-0">SEO & SMM</v-card-text>
                        </v-responsive>
                    </v-card>
                </router-link>
            </v-flex>
            <v-flex v-if="getUserRole === 2 || getUserRole === 1 || getUserRole === -1">
                <router-link to="/site">
                    <v-card class="v-card--accounts">
                        <v-responsive>
                            <img src="/static/img/root/3.svg" alt=""/>
                            <v-card-text class="px-0">Управление сайтом</v-card-text>
                        </v-responsive>
                    </v-card>
                </router-link>
            </v-flex>
            <v-flex v-if="getUserRole === 2 || getUserRole === 1 || getUserRole === -1">
                <router-link to="/catalog">
                    <v-card class="v-card--accounts">
                        <v-responsive>
                            <img src="/static/img/root/5.svg" alt=""/>
                            <v-card-text class="px-0">Управление контентом</v-card-text>
                        </v-responsive>
                    </v-card>
                </router-link>
            </v-flex>
            <v-flex v-if="getUserRole === 5 || getUserRole === 1 || getUserRole === -1">
                <router-link to="/head">
                    <v-card class="v-card--accounts">
                        <v-responsive>
                            <img src="/static/img/root/4.svg" alt=""/>
                            <v-card-text class="px-0">Панель руководителя</v-card-text>
                        </v-responsive>
                    </v-card>
                </router-link>
            </v-flex>
        </v-layout>
        <Footer/>
    </v-layout>
</template>

<script>
    import { mapGetters } from 'vuex'
    import Footer from '../../components/Footer/Layout'

    export default {
        name: 'homeLayout',
        components: { Footer },
        methods: {
            logOut () {
                this.$store.commit('logOutUser')
                this.$router.push({ name: 'login' })
            }
        },

        computed: {
            ...mapGetters([
                'getProjectId',
                'getUserRole',
                'getUserName',
            ])
        },

        created () {
            this.setHeaderTitle('Главная')
        }
    }
</script>

<style lang="scss">
    @import "../../assets/styles/colors";
    @import "../../assets/styles/fonts";

    .v-btn {
        &:not(.v-btn--text) {
            color: $white !important;
        }
    }

    .v {
        &-card {
            &--accounts {
                margin: 1rem;
                width: 250px;
                height: 250px;
                box-shadow: none;
                border-radius: 10px;

                &:hover {
                    cursor: pointer;
                    transform: translateY(-10px);
                }

                .v {
                    &-responsive {
                        width: 100%;
                        height: 100%;
                        align-items: center;
                        justify-content: center;

                        &__content {
                            flex: initial;
                        }
                    }

                    &-btn {
                        color: $white !important;
                    }

                    &-card {
                        &__text {
                            color: $black;
                            text-align: center;
                            font: 400 0.874rem $fontFamily;
                        }
                    }
                }
            }
        }
    }

    .home {
        &-user {
            &_name {
                color: $white;
                padding: 16px;
                display: inline-block;
                font: 400 1rem $fontFamily;
            }
        }

        &-img {
            display: block;
            margin: auto;
        }
    }

    .btn {
        &-clear {
            &.theme--light {
                color: $white;
                text-transform: none;
                font: 400 1rem $fontFamily;
                box-shadow: none !important;
                background: transparent !important;
            }
        }
    }
</style>
